import styled from 'styled-components';

export const DepositQRCodeCopiedStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 8px 24px;
    
    h3 {
        font-weight: 500;
        font-size: 20px;
        color: var(--color-white);
    }
    
    p {
        font-size: 16px;
        font-weight: 400;
        color: var(--color-white-95);
        margin-top: 16px;
        margin-bottom: 0;
    }
`;
